export default {
  requestVideo_title: 'Request video',
  requestVideo_unit_label: 'Select a unit',
  requestVideo_unit_placeholder: 'Search by name or serial number',
  requestVideo_unit_none: 'No LightMetrics units found.',
  requestVideo_unit_loading: 'Searching units...',
  requestVideo_unit_error: 'The units could not be loaded.',
  requestVideo_unit_loadMore: 'Load more units',
  requestVideo_unit_empty: 'Select a unit to request a video.',
  requestVideo_unit_notFound: 'That camera was not found among your LightMetrics units.',
  requestVideo_zone_note: 'Times are shown in {timeZone}.',
  requestVideo_zone_fallback: 'This unit has no time zone configured. Times are shown in UTC.',
  requestVideo_days_loading: 'Loading days with activity...',
  requestVideo_days_none: 'No activity in the last 90 days.',
  requestVideo_days_error: 'The days with activity could not be loaded.',
  requestVideo_day_label: 'Day',
  requestVideo_day_prev: 'Previous day with activity',
  requestVideo_day_next: 'Next day with activity',
  requestVideo_day_choose: 'Choose a day',
  requestVideo_trips_title: 'Trips',
  requestVideo_trips_loading: 'Loading trips...',
  requestVideo_trips_none: 'No trips on this day.',
  requestVideo_trips_error: 'The trips could not be loaded.',
  requestVideo_trip_driver: 'Driver: {name}',
  requestVideo_trip_noDriver: 'No driver',
  requestVideo_retry: 'Retry',
  requestVideo_window_title: '5-minute window',
  requestVideo_window_prev: 'Previous 5 minutes',
  requestVideo_window_next: 'Next 5 minutes',
  requestVideo_trail_loading: 'Loading trail...',
  requestVideo_trail_empty: 'No trail data in this window.',
  requestVideo_trail_error: 'The trail could not be loaded. You can still choose the range.',
  requestVideo_legend_driving: 'Driving',
  requestVideo_legend_idling: 'Idling',
  requestVideo_legend_stopped: 'Stopped',
  requestVideo_legend_camera: 'Camera event',
  requestVideo_marker_label: 'Camera event at {time}',
  requestVideo_handle_start: 'Clip start',
  requestVideo_handle_end: 'Clip end',
  requestVideo_range_title: 'Clip range',
  requestVideo_range_from: 'From',
  requestVideo_range_to: 'To',
  requestVideo_lmTrips_other: 'Another LightMetrics trip',
  requestVideo_lmTrips_hint: 'LightMetrics only records inside one of its own trips. The faded part is another trip: click it to move the clip there.',
  requestVideo_range_duration: 'Duration: {value}',
  requestVideo_rangeError_tooLong: 'The clip can be at most 5 minutes long.',
  requestVideo_rangeError_outside: 'The clip must stay inside the selected window.',
  requestVideo_rangeError_missing: 'Select a trip to choose the clip range.',
  requestVideo_private_label: 'Private clip request',
  requestVideo_private_tooltip: 'A private clip is only visible to users who have permission to view private clips.',
  requestVideo_submit: 'Request video',
  requestVideo_sending: 'Sending...',
  requestVideo_cancel: 'Cancel',
  requestVideo_toast_title: 'Video requested',
  requestVideo_toast_body: 'The clip has been successfully requested. It will appear in Video > Requested when the camera uploads it.',
  requestVideo_error_alreadyRequested: 'This clip was already requested.',
  requestVideo_error_cameraNotFound: 'The camera was not found.',
  requestVideo_error_rangeNotAvailable: 'The camera cannot provide video for that range. Choose a different one.',
  requestVideo_error_generic: 'The request could not be sent. Please try again.',
};
